import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "form_box"
};
const _hoisted_2 = {
  key: 0,
  class: "drive_url m-l-20"
};
const _hoisted_3 = {
  class: "bottom_box"
};
const _hoisted_4 = {
  class: "text-r"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_col = _resolveComponent("el-col");
  const _component_el_row = _resolveComponent("el-row");
  const _component_el_input = _resolveComponent("el-input");
  const _component_el_form_item = _resolveComponent("el-form-item");
  const _component_el_upload = _resolveComponent("el-upload");
  const _component_m_chunk_upload = _resolveComponent("m-chunk-upload");
  const _component_el_form = _resolveComponent("el-form");
  const _component_el_button = _resolveComponent("el-button");
  const _component_el_image = _resolveComponent("el-image");
  const _component_el_dialog = _resolveComponent("el-dialog");
  const _component_el_main = _resolveComponent("el-main");
  return _openBlock(), _createBlock(_component_el_main, {
    class: "bg_white",
    style: {
      "min-height": "calc( 100% - 80px )"
    }
  }, {
    default: _withCtx(() => [_createVNode(_component_el_row, {
      class: "title_box"
    }, {
      default: _withCtx(() => [_createVNode(_component_el_col, {
        span: 24
      }, {
        default: _withCtx(() => _cache[9] || (_cache[9] = [_createElementVNode("div", {
          class: "title"
        }, "驱动管理", -1)])),
        _: 1,
        __: [9]
      })]),
      _: 1
    }), _createElementVNode("div", _hoisted_1, [_createVNode(_component_el_form, {
      ref: "ruleForms",
      rules: $setup.data.rules,
      model: $setup.data.formData,
      "label-width": "120px",
      "label-position": "left"
    }, {
      default: _withCtx(() => [_createVNode(_component_el_form_item, {
        label: "驱动名称：",
        prop: "name"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_input, {
          modelValue: $setup.data.formData.name,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $setup.data.formData.name = $event)
        }, null, 8, ["modelValue"])]),
        _: 1
      }), _createVNode(_component_el_form_item, {
        label: "驱动标签：",
        prop: "tags"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_input, {
          modelValue: $setup.data.formData.tags,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => $setup.data.formData.tags = $event),
          placeholder: "请以英文字符‘,’分隔的方式输入标签"
        }, null, 8, ["modelValue"])]),
        _: 1
      }), _createVNode(_component_el_form_item, {
        label: "驱动描述：",
        prop: "description"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_input, {
          modelValue: $setup.data.formData.description,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => $setup.data.formData.description = $event),
          rows: 3,
          type: "textarea",
          placeholder: "驱动描述"
        }, null, 8, ["modelValue"])]),
        _: 1
      }), _createVNode(_component_el_form_item, {
        label: "封面图：",
        prop: ""
      }, {
        default: _withCtx(() => [_createVNode(_component_el_upload, {
          ref: "upload",
          action: $setup.data.api_upload_url,
          "file-list": $setup.data.formData.show_img,
          "onUpdate:fileList": _cache[3] || (_cache[3] = $event => $setup.data.formData.show_img = $event),
          "list-type": "picture-card",
          "with-credentials": true,
          name: "image",
          data: $setup.data.extra,
          "on-success": function (res, file, file_list) {
            return $setup.handleSuccess(res, file, file_list, $setup.data.formData);
          },
          "on-preview": $setup.handlePreview,
          limit: 1,
          "on-remove": $setup.handleRemove,
          accept: ".jpg,.png"
        }, {
          default: _withCtx(() => _cache[10] || (_cache[10] = [_createElementVNode("i", {
            class: "el-icon-plus"
          }, null, -1)])),
          _: 1,
          __: [10]
        }, 8, ["action", "file-list", "data", "on-success", "on-preview", "on-remove"])]),
        _: 1
      }), _createVNode(_component_el_form_item, {
        label: "适配型号：",
        prop: "product_sn"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_input, {
          modelValue: $setup.data.formData.product_sn,
          "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => $setup.data.formData.product_sn = $event),
          placeholder: "请以英文字符‘,’分隔的方式输入标签"
        }, null, 8, ["modelValue"])]),
        _: 1
      }), _createVNode(_component_el_form_item, {
        label: "支持系统：",
        prop: "os"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_input, {
          modelValue: $setup.data.formData.os,
          "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => $setup.data.formData.os = $event)
        }, null, 8, ["modelValue"])]),
        _: 1
      }), _createVNode(_component_el_form_item, {
        label: "驱动上传：",
        prop: "url"
      }, {
        default: _withCtx(() => [_createVNode(_component_m_chunk_upload, {
          "chunk-size": 1,
          "request-limit": 4,
          onSuccessed: _cache[6] || (_cache[6] = $event => $setup.completeInfoUpload($event, {
            index: '-1'
          })),
          onUploadProgress: _ctx.progress,
          onHashProgress: _ctx.hash
        }, {
          default: _withCtx(() => _cache[11] || (_cache[11] = [_createElementVNode("span", {
            class: "opd-btn opd-btntype3"
          }, "上传文件", -1)])),
          _: 1,
          __: [11]
        }, 8, ["onUploadProgress", "onHashProgress"]), $setup.data.formData.url ? (_openBlock(), _createElementBlock("div", _hoisted_2, [_createTextVNode(_toDisplayString($setup.data.formData.url) + " ", 1), _createElementVNode("i", {
          class: "el-icon-circle-close",
          style: {
            "margin-left": "5px"
          },
          onClick: _cache[7] || (_cache[7] = (...args) => $setup.close && $setup.close(...args))
        })])) : _createCommentVNode("", true)]),
        _: 1
      })]),
      _: 1
    }, 8, ["rules", "model"])]), _createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createVNode(_component_el_button, {
      type: "primary",
      onClick: $setup.addClick
    }, {
      default: _withCtx(() => _cache[12] || (_cache[12] = [_createTextVNode("确定")])),
      _: 1,
      __: [12]
    }, 8, ["onClick"])])]), _createVNode(_component_el_dialog, {
      modelValue: $setup.data.dialogVisible,
      "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => $setup.data.dialogVisible = $event)
    }, {
      default: _withCtx(() => [_createVNode(_component_el_image, {
        width: "100%",
        src: $setup.data.dialogImg,
        alt: ""
      }, null, 8, ["src"])]),
      _: 1
    }, 8, ["modelValue"])]),
    _: 1
  });
}